<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted } from 'vue'
import { Head } from '@inertiajs/inertia-vue3'
import usePref from '@/Shared/usePref.js'
import Pagenation from './Pagenation'

const props = defineProps({
  pref: Object,
})

onMounted(() => {
  usePref(props.pref)
})
</script>

<template>
  <div class="about history">
    <Head title="A&F40年の歴史を、創業者・赤津孝夫が振り返る。" />
    <div class="pb-[50px] sm:pt-[20px]">
      <h2 class="page-title">
        History
        <small>A&amp;Fの歴史</small>
      </h2>
      <div class="m-auto px-[calc(5vw_+_10px)] xs:px-[40px] sm:px-[60px] lg:px-0 max-w-[500px] sm:max-w-[840px]">
        <Pagenation :page="3" />

        <div class="section">
          <div class="right"><img src="https://img.aandf.co.jp/aandfcojp/img/corporate/about_img3_1.png" alt="" /></div>
          <div class="left">
            <h3>進化した素材やテクノロジーを採用した<br />ブランドや商品の台頭</h3>
            <p>2000年からはカタログの発行サイクルを毎年にしました。チタン製品がちょっとずつ出てきたり、LEDライトが初めて登場した頃ですね。アジア方面へバックパックの旅に出る若者も増えたんじゃないでしょうか。</p>
            <p>フリースなどの化繊製品全盛の時代にIBEXというウールジャケットのブランドを始めました。ローデンウールと呼ばれる、スチームでウールを圧縮して目を詰めた生地がすごくいい。COCOONというシルク素材のトラベルシーツは、寝袋のインナーとしても使えますし、バックパッカーが安宿に泊まったときに布団の中にもう一枚敷いても良いので重宝しますよ。</p>
          </div>
        </div>
        <div class="section">
          <div class="left"><img src="https://img.aandf.co.jp/aandfcojp/img/corporate/about_img3_2.png" alt="" /></div>
          <div class="right">
            <h3>表紙のイラストがアメリカの公園シリーズに</h3>
            <p>この総合カタログ以外に5冊のブランドカタログを作っていました。高性能テントブランドのHILLBERGを取扱い始めたのが2003年のカタログからですね。この頃すでに取扱ブランドは100を超えていたと思います。Pendletonも大きく成長しましたし、VASQUEはアメリカで森を守る“フォレストレンジャー”と呼ばれる人たちの御用達ブーツという実力派です。</p>
            <p>2005年からは表紙のイラストをアメリカの国立公園シリーズにしました。2005年はグランドキャニオン、2006年はアパラチアントレイル、そして2007年がアディロンダックというアメリカで一番古い州立公園です。</p>
          </div>
        </div>
        <div class="section">
          <div class="right"><img src="https://img.aandf.co.jp/aandfcojp/img/corporate/about_img3_3.png" alt="" /></div>
          <div class="left">
            <h3>自分が使いたいと思えるものを取扱う<br />という基本的な考え</h3>
            <p>表紙は引き続き国立公園シリーズで、2008年はロッキーマウンテン、2009年イエローストーン、2010年がアラスカのグレイシャーベイ、2011年がモニュメントバレー。</p>
            <p>ORというブランドを2009年から取扱い始めましたけど、きっかけはずいぶん前の夏のアラスカでした。亡くなった写真家の星野道夫さんの思い出をたどって息子と娘を連れて訪れたとき、僕は夏用のスリーピングバッグを持っていったんですが流石に寒くてね。急遽買ったORのビビィサックがすごく良かったんです。自分がアウトドアで使ってみて、これからも使いたいと思えるものを取り扱うというのがわたしたちの基本的な考え方ですね。</p>
          </div>
        </div>

        <Pagenation :page="3" />
      </div>
    </div>
  </div>
</template>
